import {VehicleListStatusBadge} from "@/src/modules/vehicles/components/vehicle-list-status-badge";
import type {Vehicle} from "@/src/modules/vehicles/types";
import {cn} from "@/lib/utils";

import {
  getVehicleCheckEnforcementStatusRows,
  type VehicleCheckMatchStatusRow,
} from "../lib/vehicle-check-match-status";

const LIST_BADGE_CLASS = "!px-1.5 !py-0.5 text-[11px]";

type VehicleCheckMatchStatusProps = {
  vehicle: Vehicle;
  className?: string;
};

function StatusCell({
  label,
  display,
}: {
  label: string;
  display: VehicleCheckMatchStatusRow["display"];
}) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <span className="text-muted-foreground text-xs font-medium">{label}</span>
      <VehicleListStatusBadge display={display} className={LIST_BADGE_CLASS} />
    </div>
  );
}

export function VehicleCheckMatchStatus({vehicle, className}: VehicleCheckMatchStatusProps) {
  const [stored, citation] = getVehicleCheckEnforcementStatusRows(vehicle);

  return (
    <div className={cn("grid grid-cols-2 gap-3", className)}>
      <StatusCell label={stored.label} display={stored.display} />
      <StatusCell label={citation.label} display={citation.display} />
    </div>
  );
}
